import { render, staticRenderFns } from "./CallNote.vue?vue&type=template&id=449c5e10&scoped=true&"
import script from "./CallNote.vue?vue&type=script&lang=js&"
export * from "./CallNote.vue?vue&type=script&lang=js&"
import style0 from "./CallNote.vue?vue&type=style&index=0&id=449c5e10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449c5e10",
  null
  
)

export default component.exports